<template>
  <v-container>
    <PersonalForm v-if="$route.params.formName === 'personalForm'" />
    <NewInvestigatorForm
      v-if="$route.params.formName === 'newInvestigatorForm'"
    />
    <ExternalPeopleAccountForm
      v-if="$route.params.formName === 'externalPeopleForm'"
    />
    <VacationForm v-if="$route.params.formName === 'vacationForm'" />
    <VinculationForm v-if="$route.params.formName === 'vinculationForm'" />
    <ModifyVinculationForm
      v-if="$route.params.formName === 'modifyVinculationForm'"
    />
    <ModifyExpirationDate
      v-if="$route.params.formName === 'modifyExpirationDateForm'"
    />
    <WorkplaceForm v-if="$route.params.formName === 'modifyWorkplaceForm'" />
    <ExtendWorkplaceAssignationForm
      v-if="$route.params.formName === 'workplaceAssignationForm'"
    />
    <ModifyResponsibleForm
      v-if="$route.params.formName === 'modifyResponsibleForm'"
    />
    <ModifyServicesForm
      v-if="$route.params.formName === 'modifyServicesForm'"
    />
    <AffiliationForm v-if="$route.params.formName === 'affiliationForm'" />
  </v-container>
</template>

<script>
import VacationForm from "./VacationForm";
import ExternalPeopleAccountForm from "./ExternalPeopleAccountForm";
import PersonalForm from "./PersonalForm";
import NewInvestigatorForm from "./NewInvestigatorForm";
import VinculationForm from "./VinculationForm";
import ModifyVinculationForm from "./ModifyVinculationForm";
import ModifyExpirationDate from "./ModifyExpirationDateForm";
import WorkplaceForm from "./WorkplaceForm";
import ExtendWorkplaceAssignationForm from "./ExtendWorkplaceAssignationForm";
import ModifyResponsibleForm from "./ModifyResponsibleForm";
import ModifyServicesForm from "./ModifyServicesForm";
import AffiliationForm from "./AffiliationForm";
import axios from "axios";
export default {
  components: {
    ModifyServicesForm,
    ModifyResponsibleForm,
    WorkplaceForm,
    ModifyExpirationDate,
    ModifyVinculationForm,
    VinculationForm,
    NewInvestigatorForm,
    PersonalForm,
    ExternalPeopleAccountForm,
    VacationForm,
    ExtendWorkplaceAssignationForm,
    AffiliationForm
  },
  name: "InvestigatorForms",

  data() {
    return {
      name: ""
    };
  },

  methods: {
    setBreadcrumb() {
      let investigator = {
        text: this.name,
        exact: true,
        href: "/researchers/" + this.$route.params.id,
        last: true
      };
      let form = {
        text: "section." + this.$route.params.formName,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.push(investigator);
        }
        this.$route.meta.breadCrumb.push(form);
      } else {
        this.$route.meta.breadCrumb.pop();
        if (this.$route.meta.update) {
          this.$route.meta.breadCrumb.pop();
          this.$route.meta.breadCrumb.push(investigator);
        }
        this.$route.meta.breadCrumb.push(form);
      }
      this.$store.state.sectionTitle = "section." + this.$route.params.formName;
    },
    getInvestigator() {
      const path =
        this.$store.state.endpoint + "/person/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.name = response.data.preferred_name.given_name + " " + response.data.preferred_name.family_name;
        })
        .finally(this.setBreadcrumb)
        .catch(error => {
          console.log(error);
        });
    }
  },

  created() {
    this.getInvestigator();
  },

  updated() {
    this.getInvestigator();
  }
};
</script>

<style scoped></style>
